import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Edit } from 'jbc-front/components/icons';
import { Headding, Item, Panel } from '@/components/PrimaryPanel';
import { Label } from 'jbc-front/components/presenters/form/Label';
import { BoxDouble } from '@/components/Box';
import { Dl } from '@/components/ui/DefinitionList';
import { displayFormat } from '@/components/utils/formatter';
import { ViewProps } from './ViewProps';

const ITEM_CODES = [
  { code: 'hearing_1000hz', label: '聴力検査（オージオメーターによる検査）(1000Hz)' },
  { code: 'hearing_4000hz', label: '聴力検査（オージオメーターによる検査）(4000Hz)' },
  { code: 'hearing_other', label: '聴力検査（その他の方法による検査）' },
  { code: 'chest_x_ray', label: '胸部エックス線検査' },
  { code: 'sputum_test', label: '喀痰検査' },
  { code: 'blood_pressure', label: '血圧' },
  { code: 'anemia_test', label: '貧血検査' },
  { code: 'liver_function_test', label: '肝機能検査' },
  { code: 'blood_lipid_test', label: '血中脂質検査' },
  { code: 'blood_sugar_test', label: '血糖検査' },
  { code: 'urine_sugar', label: '尿検査（糖）' },
  { code: 'urine_protein', label: '尿検査（蛋白）' },
  { code: 'electrocardiogram', label: '心電図検査' }
];

const ITEM_CODES_MAP = ITEM_CODES.reduce(
  (item, { code, label }) => {
    item[code] = label;
    return item;
  },
  {} as { [key: string]: string }
);

export const HealthCheckupSummaries: FC<ViewProps> = ({ report, editLink }) => {
  return (
    <Panel>
      <Link to={`${editLink}#health_checkup_summaries`}>
        <Headding icon={<Edit icon={16} />}>健康診断項目</Headding>
      </Link>
      <Item>
        {report.resultSummaries?.map((resultSummary, index) => (
          <Panel key={index}>
            <Headding>{ITEM_CODES_MAP[resultSummary.itemCode]}</Headding>
            <Item>
              <BoxDouble>
                <div>
                  <Label>実施者数</Label>
                  <Dl>{displayFormat(`${resultSummary.totalCount}人`)}</Dl>
                </div>
                <div>
                  <Label>有所見者数</Label>
                  <Dl>{displayFormat(`${resultSummary.hasFindingCount}人`)}</Dl>
                </div>
              </BoxDouble>
            </Item>
          </Panel>
        ))}
      </Item>
    </Panel>
  );
};
